/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiToolsGet } from '../fn/tools/api-tools-get';
import { ApiToolsGet$Params } from '../fn/tools/api-tools-get';
import { apiToolsIdDelete } from '../fn/tools/api-tools-id-delete';
import { ApiToolsIdDelete$Params } from '../fn/tools/api-tools-id-delete';
import { apiToolsIdGet } from '../fn/tools/api-tools-id-get';
import { ApiToolsIdGet$Params } from '../fn/tools/api-tools-id-get';
import { apiToolsPost } from '../fn/tools/api-tools-post';
import { ApiToolsPost$Params } from '../fn/tools/api-tools-post';
import { apiToolsPut } from '../fn/tools/api-tools-put';
import { ApiToolsPut$Params } from '../fn/tools/api-tools-put';
import { apiToolsTestPost } from '../fn/tools/api-tools-test-post';
import { ApiToolsTestPost$Params } from '../fn/tools/api-tools-test-post';
import { CreateResult } from '../models/create-result';
import { CreateToolResult } from '../models/create-tool-result';
import { GetToolResult } from '../models/get-tool-result';
import { GetToolsResult } from '../models/get-tools-result';
import { TestToolResult } from '../models/test-tool-result';


/**
 * Agent tools
 */
@Injectable({ providedIn: 'root' })
export class ToolsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiToolsGet()` */
  static readonly ApiToolsGetPath = '/api/Tools';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsGet$Response(params?: ApiToolsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolsResult>> {
    const obs = apiToolsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsGet(params?: ApiToolsGet$Params, context?: HttpContext): Observable<GetToolsResult> {
    const resp = this.apiToolsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetToolsResult>): GetToolsResult => r.body)
    );
  }

  /** Path part for operation `apiToolsPut()` */
  static readonly ApiToolsPutPath = '/api/Tools';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsPut$Response(params?: ApiToolsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiToolsPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsPut(params?: ApiToolsPut$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiToolsPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiToolsPost()` */
  static readonly ApiToolsPostPath = '/api/Tools';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsPost$Response(params?: ApiToolsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateToolResult>> {
    const obs = apiToolsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsPost(params?: ApiToolsPost$Params, context?: HttpContext): Observable<CreateToolResult> {
    const resp = this.apiToolsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateToolResult>): CreateToolResult => r.body)
    );
  }

  /** Path part for operation `apiToolsIdGet()` */
  static readonly ApiToolsIdGetPath = '/api/Tools/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsIdGet$Response(params: ApiToolsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolResult>> {
    const obs = apiToolsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsIdGet(params: ApiToolsIdGet$Params, context?: HttpContext): Observable<GetToolResult> {
    const resp = this.apiToolsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetToolResult>): GetToolResult => r.body)
    );
  }

  /** Path part for operation `apiToolsIdDelete()` */
  static readonly ApiToolsIdDeletePath = '/api/Tools/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsIdDelete$Response(params: ApiToolsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiToolsIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiToolsIdDelete(params: ApiToolsIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiToolsIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiToolsTestPost()` */
  static readonly ApiToolsTestPostPath = '/api/Tools/test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiToolsTestPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsTestPost$Response(params?: ApiToolsTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestToolResult>> {
    const obs = apiToolsTestPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiToolsTestPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiToolsTestPost(params?: ApiToolsTestPost$Params, context?: HttpContext): Observable<TestToolResult> {
    const resp = this.apiToolsTestPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestToolResult>): TestToolResult => r.body)
    );
  }

}
